/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import PulseLoader from "react-spinners/PulseLoader";
import { Tooltip } from "react-tooltip";
import { Image } from "hesus-ui-kit";
import { handleApiError } from "@utils/errorHandler";
import SolutionView from "../../../../Solution/SolutionView/SolutionView";
import commentIcon from "@icons/ic-comment-blue.svg";
import copyIcon from "@icons/duplicate.svg";

import {
  renderPriceWithCurrency,
  addSpace,
  getConvertedPrice,
} from "@utils/utils";
import UserInfo from "@utils/UserInfo";
import {
  GridItem,
  LinesHeaderWrapper,
  DivToolTip,
  GridRow,
  GridSubItem,
  FlexRowDuplicate,
  DuplicateLines,
} from "./OrderPlanningHistory.styled";
import "../../SupplierList.scss";

const SupplierPlanningHistoryList = (props) => {
  const {
    t,
    planningLines,
    exchangeRates,
    quoteCurrency,
    clientOrderId,
    setRefreshState,
  } = props;

  const [orderService, setOrderService] = useState({
    needCenter: false,
    needCarrier: false,
  });

  const userDetails = UserInfo.getUser();

  const [currentSolution, setCurrentSolution] = useState(null);
  const [lineId, setLineId] = useState("");
  const [isSolutionViewPopupVisible, setSolutionViewPopupVisibility] =
    useState(false);

  const onSolutionIdClick = (solutionId) => {
    setSolutionViewPopupVisibility(false);
    axios
      .get(`/solutions/${solutionId}`)
      .then((response) => {
        setCurrentSolution(response.data[0]);
        setSolutionViewPopupVisibility(true);
      })
      .catch((error) => {
        handleApiError(error);
        setCurrentSolution();
        setSolutionViewPopupVisibility(false);
      });
  };

  const onSolutionViewClose = () => {
    setSolutionViewPopupVisibility(false);
  };

  const duplicatePlanningLines = (solutionId) => {
    setSolutionViewPopupVisibility(false);
    axios
      .post(
        `/clientOrders/${clientOrderId}/duplicatePlanningLines?adminId=${userDetails.id}`,
        solutionId
      )
      .then(() => {
        setLineId("");
        setRefreshState(true);
      })
      .catch((error) => handleApiError(error));
  };

  const duplicateLines = (id) => {
    setLineId(id);
    duplicatePlanningLines([id]);
  };

  const duplicateAllLines = (id) => {
    const lineIds = [];
    planningLines?.map((line, lineIndex) => {
      if (line?.lineGroupId) lineIds.push(line?.lineGroupId);
    });
    setLineId("all");
    duplicatePlanningLines(lineIds);
  };

  useEffect(() => {
    let tempService = orderService;
    planningLines?.[0]?.supplierPlanningLine?.map((line) => {
      if (line.hesusService.needCenter)
        tempService = { ...tempService, needCenter: true };

      if (line.hesusService.needCarrier)
        tempService = { ...tempService, needCarrier: true };
    });
    setOrderService(tempService);
  }, [planningLines]);

  return (
    <>
      {planningLines?.length === 0 && (
        <GridRow>
          <GridSubItem textAlign="center">
            {t("CLIENT_ORDER_NO_PLANNING_LINES")}
          </GridSubItem>
        </GridRow>
      )}

      {planningLines?.length > 0 && (
        <>
          {lineId !== "all" && (
            <FlexRowDuplicate onClick={duplicateAllLines}>
              <Image
                src={copyIcon}
                className="supplier-list__supplier-planning-icon"
                styles={{ marginTop: "-3px" }}
                alt={t("SUPPLIERS_PLANNING_DUPLICATE_ALL_PLANNING_LINES")}
                title={t("SUPPLIERS_PLANNING_DUPLICATE_ALL_PLANNING_LINES")}
              />
              <DuplicateLines color="#008395">
                {t("SUPPLIERS_PLANNING_DUPLICATE_ALL_PLANNING_LINES")}
              </DuplicateLines>
            </FlexRowDuplicate>
          )}

          {lineId === "all" && (
            <FlexRowDuplicate>
              <PulseLoader color="#008395" size={15} />
            </FlexRowDuplicate>
          )}
          <LinesHeaderWrapper>
            <GridRow
              column={
                orderService.needCenter && orderService.needCarrier
                  ? "38.8% 38.6% 7.7% 8.4% auto"
                  : "77.4% 7.7% 8.4% auto"
              }
              marginBottom="0px"
              gridGap="0rem"
              gap="0rem"
              marginTop="10px"
            >
              {orderService.needCenter && (
                <GridItem
                  textAlign="left"
                  fontWeight="700"
                  radius="5px 0px 0px 0px"
                  borderRight="1px solid #fff"
                >
                  {t("SUPPLIERS_PLANNING_SOLUTION")}
                </GridItem>
              )}
              {orderService.needCarrier && (
                <GridItem
                  textAlign="left"
                  fontWeight="700"
                  borderRight="1px solid #fff"
                >
                  {t("SUPPLIERS_PLANNING_HAULIER")}
                </GridItem>
              )}
              <GridItem fontWeight="700" borderRight="1px solid #fff">
                {t("SUPPLIERS_PLANNING_PLANNED")}
              </GridItem>
              <GridItem fontWeight="700" borderRight="1px solid #fff">
                {t("SUPPLIERS_PLANNING_MARGIN")}
              </GridItem>
              <GridItem
                fontWeight="700"
                radius="0px 5px 0px 0px"
                borderRight="0px solid #767676"
              >
                {t("SUPPLIERS_PLANNING_ACTIONS")}
              </GridItem>
            </GridRow>
          </LinesHeaderWrapper>

          {planningLines?.map((line, lineIndex) => {
            if (line?.supplierPlanningLine) {
              const len = Object.keys(line?.supplierPlanningLine).length - 1;
              return (
                <React.Fragment
                  key={"supplier-planning-line-group" + line?.lineGroupId}
                >
                  <GridRow
                    gap="0rem"
                    column="93.5% auto"
                    borderBottom="2px solid #767676"
                    key={`service-item-${line?.lineGroupId}${lineIndex}`}
                  >
                    <GridRow gap="0rem">
                      {line?.supplierPlanningLine.map((item, itemIndex) => {
                        return (
                          <GridRow
                            key={
                              "supplierPlanningList-" + itemIndex + "-" + item
                            }
                            column={
                              orderService.needCarrier &&
                              orderService.needCenter
                                ? "41.6% 41.3% 8.2% auto"
                                : "82.9% 8.2% auto"
                            }
                            marginBottom="0px"
                            gap="0rem"
                            marginTop="0px"
                            borderBottom={
                              itemIndex === len ? "none" : "1px solid #CCCCCC"
                            }
                          >
                            {orderService.needCenter && (
                              <GridRow
                                column="75% auto"
                                borderLeft="2px solid #767676"
                                borderRight="2px solid #767676"
                              >
                                {item.hesusService.needCenter &&
                                  (!item.hesusService.needCombination ||
                                    (item.hesusService.needCombination &&
                                      item.hesusService
                                        .needCombinationCarrier)) && (
                                    <>
                                      <GridRow gap="0rem">
                                        <GridSubItem
                                          fontWeight="700"
                                          fontSize="16px"
                                          padding="5px 5px 0px 10px"
                                        >
                                          <DuplicateLines
                                            color="#0a4986"
                                            onClick={() =>
                                              onSolutionIdClick(
                                                item.solution.solutionId
                                              )
                                            }
                                          >
                                            #{item.solution.solutionId}
                                          </DuplicateLines>{" "}
                                          - [{" "}
                                          {item.solution.centre.supplierName}] -{" "}
                                          {item.solution.centre?.name}
                                        </GridSubItem>
                                        <GridSubItem
                                          fontWeight="400"
                                          fontSize="16px"
                                          color="#474747"
                                          fontStyle="italic"
                                          padding="0px 5px 5px 10px"
                                        >
                                          {item.solution.product?.name}
                                        </GridSubItem>
                                      </GridRow>
                                      <GridSubItem
                                        fontWeight="700"
                                        fontSize="16px"
                                        textAlign="right"
                                        color="#474747"
                                      >
                                        {renderPriceWithCurrency(
                                          addSpace(
                                            getConvertedPrice(
                                              item?.solution?.currency?.id,
                                              item?.solution?.purchasePrice,
                                              exchangeRates
                                            )
                                          ),
                                          t(item?.solution?.purchaseUnit),
                                          quoteCurrency?.symbol,
                                          quoteCurrency?.position
                                        )}
                                      </GridSubItem>
                                    </>
                                  )}
                              </GridRow>
                            )}

                            {orderService.needCarrier && (
                              <GridRow
                                column="70% 5% auto"
                                borderRight="2px solid #767676"
                                borderLeft={
                                  !orderService.needCenter
                                    ? "2px solid #767676"
                                    : "none"
                                }
                                gap="0rem"
                              >
                                {item.hesusService.needCarrier &&
                                  (!item.hesusService.needCombination ||
                                    (item.hesusService.needCombination &&
                                      item.hesusService
                                        .needCombinationCenter)) && (
                                    <>
                                      <GridRow gap="0rem">
                                        <GridSubItem
                                          fontWeight="700"
                                          fontSize="16px"
                                          padding="5px 5px 0px 10px"
                                        >
                                          {item.haulage.company?.name}
                                        </GridSubItem>
                                        <GridSubItem
                                          fontWeight="400"
                                          fontSize="16px"
                                          color="#474747"
                                          fontStyle="italic"
                                          padding="0px 5px 5px 10px"
                                        >
                                          {item.haulage.transport?.name}
                                        </GridSubItem>
                                      </GridRow>
                                      <GridSubItem
                                        fontWeight="700"
                                        fontSize="16px"
                                        textAlign="right"
                                        color="#474747"
                                      >
                                        {item.haulage.comment && (
                                          <>
                                            <span
                                              id={`supplier-item-description-id${item.id}`}
                                            >
                                              <Image
                                                src={commentIcon}
                                                alt="comment"
                                                className="supplier-list__order-planning-icon"
                                              />
                                            </span>
                                            <Tooltip
                                              anchorSelect={`#supplier-item-description-id${item.id}`}
                                              style={DivToolTip}
                                              border="1px solid #0A4986"
                                            >
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html: item?.haulage.comment,
                                                }}
                                              />
                                            </Tooltip>
                                          </>
                                        )}
                                      </GridSubItem>
                                      <GridSubItem
                                        fontWeight="700"
                                        fontSize="16px"
                                        textAlign="right"
                                        color="#474747"
                                      >
                                        {renderPriceWithCurrency(
                                          addSpace(
                                            getConvertedPrice(
                                              item?.haulage?.currency?.id,
                                              item?.haulage?.purchasePrice,
                                              exchangeRates
                                            )
                                          ),
                                          t(item?.haulage?.purchaseUnit),
                                          quoteCurrency?.symbol,
                                          quoteCurrency?.position
                                        )}
                                      </GridSubItem>
                                    </>
                                  )}
                              </GridRow>
                            )}

                            <GridItem>
                              <GridSubItem
                                fontWeight="400"
                                fontSize="16px"
                                textAlign="center"
                                color="#0A4986"
                              >
                                {`${item.quantity} ${t(item.unit)}`}
                              </GridSubItem>
                            </GridItem>

                            <GridItem>
                              <GridSubItem
                                fontWeight="700"
                                fontSize="16px"
                                textAlign="center"
                                color={
                                  // eslint-disable-next-line no-nested-ternary
                                  item.marginRate >= 12
                                    ? "#0A4986"
                                    : item.marginRate <= 6
                                    ? "#E83F1E"
                                    : "#F08046"
                                }
                              >
                                {parseFloat(item.marginRate).toFixed(2)}%
                              </GridSubItem>
                            </GridItem>
                          </GridRow>
                        );
                      })}
                    </GridRow>
                    <GridRow gridGap="0rem">
                      <GridSubItem
                        fontWeight="700"
                        fontSize="16px"
                        textAlign="center"
                        borderRight="2px solid rgb(118, 118, 118)"
                      >
                        {parseInt(lineId, 10) !==
                          parseInt(line?.lineGroupId, 10) && (
                          <Image
                            src={copyIcon}
                            className="supplier-list__supplier-planning-icon"
                            onClick={() => duplicateLines(line?.lineGroupId)}
                            alt={t(
                              "SUPPLIERS_PLANNING_DUPLICATE_PLANNING_LINE"
                            )}
                            title={t(
                              "SUPPLIERS_PLANNING_DUPLICATE_PLANNING_LINE"
                            )}
                          />
                        )}
                        {parseInt(lineId, 10) ===
                          parseInt(line?.lineGroupId, 10) && (
                          <ClipLoader size={20} color="#008395" />
                        )}
                      </GridSubItem>
                    </GridRow>
                  </GridRow>
                </React.Fragment>
              );
            }
          })}
          {isSolutionViewPopupVisible && (
            <SolutionView
              onClose={onSolutionViewClose}
              id={currentSolution.id}
              solutionData={currentSolution}
              isEditBtnVisible={false}
            />
          )}
        </>
      )}
    </>
  );
};
SupplierPlanningHistoryList.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SupplierPlanningHistoryList);
